import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Button, Stack, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
export const ProductWizardFlowSelectorFooter = ({ activeStateLabel, disabledStateLabel, disabled, onClick, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const isMobile = useMediaQueryMatchesOnMobile();
    const label = disabled
        ? disabledStateLabel || t('productWizard.flow.button.selectOption')
        : activeStateLabel || t('productWizard.flow.button.findProduct');
    return (_jsx(Box, { children: _jsx(Stack, { justify: "end", children: _jsx(Button, { noBubble: true, fullWidth: isMobile, size: "sm", theme: "branded", text: label, onClick: onClick, state: disabled ? 'disabled' : 'interactive' }) }) }));
};
